<script setup>
import { ref, computed, reactive } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { verificationNumberPhone, verificationCodeSms } from '@/utils/services';
import SertHeader from '@/components/blocks/SertHeader.vue';
import BaseInput from '@/components/ui/BaseInput.vue';
import PhoneInput from '@/components/ui/PhoneInput.vue';

const storeSert = useSertStore();
const responseError = ref(false);
const responseText = ref('');
const responseCodeError = ref(false);
const responseCodeText = ref('');
const responseCodeIconActive = ref(false);


const isDisabled = computed(() => {
    return storeSert.disabledButtons.firstName &&
           storeSert.disabledButtons.email &&
           storeSert.disabledButtons.phone &&
           storeSert.disabledButtons.confirmationCode &&
           storeSert.disabledButtons.activeCode;
});

const handleNext = async () => {
    await storeSert.saveUser()
    storeSert.goToScreen(storeSert.screens.checked)
}

const checkedPhone = async() => {
    storeSert.updateDisabledButton('activeCode', false)
    try {
        const response =  await verificationNumberPhone({phone_number: storeSert.checkedItems.phone})
        storeSert.timer();
    } catch (error) {
        if(error.response.status === 550){
            responseError.value = true;
            responseText.value = error.response.data.detail;
        }
        console.log('verificationNumberPhone:', error);
    } finally {
        setTimeout(() => {
            responseError.value = false;
            responseText.value = '';
        }, 3000)
    }   
}

const checkedCodeSms = async() => {
    storeSert.updateDisabledButton('activeCode', true)
    try {
        const response =  await verificationCodeSms({code: storeSert.checkedItems.confirmationCode})
        responseCodeIconActive.value = true;
    } catch (error) {
        if(error.response.status === 553 || error.response.status === 554 || error.response.status === 403){
            responseCodeError.value = true;
            responseCodeText.value = error.response.data.detail;
        }
        console.log('verificationNumberPhone:', error);
    } finally {
        setTimeout(() => {
            responseCodeError.value = false;
            responseCodeText.value = '';
        }, 3000)
    }   
}

</script>
<template>
    <div class="constructor">
        <div class="constructor__body">
            <SertHeader :white-steps="5">
                <template #title>Заполнение данных покупателя и оплата</template>
                <template #text>Введите свои контактные данные и данные для оплаты. После успешной оплаты сертификат будет отправлен на указанный email</template>
            </SertHeader>            
            <div class="form --form-pay">
                <div class="form__row --two-col">
                    <BaseInput 
                        type="text" 
                        placeholder="Укажите ваше имя"
                        state-key="firstName" 
                        v-model="storeSert.checkedItems.firstName"
                    >
                        Ваше имя
                    </BaseInput>
                    <BaseInput 
                        type="text" 
                        placeholder="Укажите свой e-mail"
                        state-key="email" 
                        v-model="storeSert.checkedItems.email"
                    >
                        Свой e-mail
                    </BaseInput>
                </div>
                
                <div :class="['form__row --two-col-btn --grid-items-end', ]">
                    <PhoneInput 
                        :response-error
                        :response-text
                        placeholder="Укажите номер телефона"
                        state-key="phone" 
                        v-model="storeSert.checkedItems.phone"                        
                    >
                        Номер телефона
                    </PhoneInput>
                    <button 
                        @click="checkedPhone"
                        :disabled="!storeSert.disabledButtons.phone" 
                        class="btn btn-submit --full"
                        >
                        отправить код
                    </button>
                </div>
                <div :class="['form__row --two-col-btn --grid-items-end', ]">
                    <div class="form__row-inner">
                        <Transition>
                            <svg v-if="responseCodeIconActive" width='24' height='24'><use href='#check-circle'></use></svg>
                        </Transition>
                        <BaseInput 
                            type="number" 
                            placeholder="Введите код подтвердждения"
                            state-key="confirmationCode" 
                            v-model="storeSert.checkedItems.confirmationCode"
                            :response-code-error
                            :response-code-text
                        >
                            Код подтвердждения
                        </BaseInput>
                        
                        <Transition>
                            <div 
                                v-if="storeSert.timerDescActive && !storeSert.disabledButtons.confirmationCode"
                                :class="['form__timer']"
                            >
                                Я не получил(а) код, 
                                <button
                                    @click="checkedPhone" 
                                    :class="{active: !storeSert.timerActive}"                                    
                                >
                                    отправить повторно 
                                    <span v-if="storeSert.timerActive">
                                        {{ `00 : ${storeSert.remainingTime.secundes}` }}
                                    </span> 
                                </button>
                            </div>
                        </Transition>
                    </div>
                    <button                         
                        :disabled="!storeSert.disabledButtons.confirmationCode" 
                        @click="checkedCodeSms"
                        class="btn btn-submit --full"
                    >
                        Отправить
                    </button>
                </div>
            </div>
        </div>
        <div class="constructor__btns">
            <a 
                :href="`#${storeSert.screens.preview}`" 
                @click="storeSert.goToScreen(storeSert.screens.preview)" 
                class="btn --black">
                Назад
            </a>
            <a                    
                :href="`#${storeSert.screens.checked}`" 
                @click="handleNext" 
                class="btn --full"
                :class="{ disabled: !isDisabled }">
                Далее
            </a>
        </div>
    </div>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>